// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3591":"1198c2f1d1399236","3643":"b789562513e81df1"}[chunkId] + ".css";
};